import React from 'react';
import { ColorPalette } from '../ColorPalette';

export const ChartPalette = () => {
  return (
    <div>
      <ColorPalette mode="copy-to-clipboard" theme="dark" />
    </div>
  );
};
